import { render, staticRenderFns } from "./Student.profile.vue?vue&type=template&id=d9963b9c"
import script from "./Student.profile.vue?vue&type=script&lang=js"
export * from "./Student.profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports